import React, { useState, useContext } from 'react';
import { FormGroup, Input, Row, Col } from 'reactstrap';
import moment from "moment";
import { Repeat } from "src/models/Appointment";
import { Util } from "src/Util";
import UserContext from "src/context/UserContext";
import { environment } from "src/environment/environment";

export default function AppointmentForm({ onSubmit, selectedDate, isSubmitting, therapistId }) {
  const [user] = useContext(UserContext);
  const [appointment, setAppointment] = useState({
    title: "Lavni Therapy session",
    startTime: "",
    endTime: "",
    date: moment().format("MM/DD/YYYY"),
    repeat: Repeat.DOES_NOT_REPEAT,
    color: "#FF6900",
    selectedDate: "",
  });

  // Checkbox states for agreements
  const [agreedToDisclosure, setAgreedToDisclosure] = useState(false);
  const [agreedToPolicy, setAgreedToPolicy] = useState(false);
  const [agreedToConsent, setAgreedToConsent] = useState(false);

  // Update form when selectedDate changes
  React.useEffect(() => {
    if (selectedDate?.start) {
      const startMoment = moment(selectedDate.start);
      setAppointment(prev => ({
        ...prev,
        title: "Lavni Therapy session",
        startTime: startMoment.format('hh:mm A'),
        endTime: moment(startMoment).add(1, 'hour').format('hh:mm A'),
        date: startMoment.format('MM/DD/YYYY'),
        selectedDate: startMoment.toISOString()
      }));
    }
  }, [selectedDate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Check if all checkboxes are checked before submitting
    if (!agreedToDisclosure || !agreedToPolicy || !agreedToConsent) {
      alert('Please agree to all terms and conditions before creating the appointment.');
      return;
    }
    onSubmit(appointment);
  };

  return (
    <form onSubmit={handleSubmit} className="awsome-area">
      <div className="title-input mb-4">
        <FormGroup>
          <Input
            className="modal-title new-input-v"
            name="title"
            type="text"
            placeholder="Add title - Optional"
            onChange={e => setAppointment({ ...appointment, title: e.target.value })}
            value={appointment.title}
            disabled={isSubmitting}
          />
          <span className="awsome_input_border" />
        </FormGroup>
      </div>

      <Row className="mb-4">
        <Col className="cont-center sm-hide" lg={1} md={1} sm={1} xs={1}>
          <i className="bx bx-time-five"></i>
        </Col>
        <Col lg={11} md={11} sm={11} xs={12}>
          <Row>
            <Col lg={4} md={4} sm={4} xs={6} className="sm-mb5">
              <Input
                type="text"
                value={appointment.date}
                disabled={true}
              />
            </Col>
            <Col lg={8} md={8} sm={8} xs={6}>
              <Input
                type="text"
                value={appointment.startTime}
                disabled={true}
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col className="cont-center sm-hide" lg={1} md={1} sm={1} xs={1}>
          <i className="bx bx-video"></i>
        </Col>
        <Col lg={11} md={11} sm={11} xs={12}>
          Video - 1 Hour Session
        </Col>
      </Row>

      <Row className="mb-4">
        <Col className="cont-center sm-hide" lg={1} md={1} sm={1} xs={1}>
          <i className={Util.meetingRepeatTypeIcon(appointment.repeat)}></i>
        </Col>
        <Col lg={11} md={11} sm={11} xs={12}>
          <Input
            type="select"
            name="repeat"
            value={appointment.repeat}
            onChange={e => setAppointment({ ...appointment, repeat: e.target.value })}
            disabled={isSubmitting}
          >
            <option value={Repeat.DOES_NOT_REPEAT}>Does not repeat</option>
            <option value={Repeat.WEEKLY}>Weekly</option>
            <option value={Repeat.BI_WEEKLY}>Bi Weekly</option>
          </Input>
        </Col>
      </Row>

      {/* Agreement Checkboxes */}
      <div style={{
        width: "100%",
        marginBottom: 20,
        padding: "16px",
        backgroundColor: "#f8f9fa",
        borderRadius: "8px",
        border: "1px solid #e9ecef"
      }}>
        <div style={{
          marginBottom: 16,
          fontSize: 16,
          fontWeight: 600,
          color: "#495057",
          textAlign: "center"
        }}>
          Please review and accept the following agreements:
        </div>

        {/* Custom checkbox #1 - Disclosure Statement */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: 16,
            cursor: "pointer",
            padding: "12px",
            backgroundColor: "white",
            borderRadius: "6px",
            border: "1px solid #dee2e6",
            transition: "all 0.2s ease",
          }}
          onClick={() => {
            setAgreedToDisclosure(!agreedToDisclosure);
          }}
        >
          <div
            style={{
              width: 20,
              height: 20,
              border: "2px solid #ccc",
              borderRadius: 4,
              marginRight: 12,
              marginTop: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: agreedToDisclosure ? "#FF8F2D" : "white",
              borderColor: agreedToDisclosure ? "#FF8F2D" : "#ccc",
              flexShrink: 0
            }}
          >
            {agreedToDisclosure && <i className="bx bx-check" style={{ color: "white", fontSize: 14 }}></i>}
          </div>
          <div style={{ color: "#495057", fontSize: 14, lineHeight: "1.4" }}>
            I have read the <span
              style={{
                color: "#FF8F2D",
                fontWeight: 600,
                textDecoration: "underline",
                cursor: "pointer"
              }}
              onClick={(e) => {
                e.stopPropagation();
                const disclosureUrl = `${environment.api_url}/api/public/disclosure-statement-of-therapist/${therapistId}`;
                window.open(disclosureUrl, '_blank');
              }}
            >disclosure statement</span> & Accept.
          </div>
        </div>

        {/* Custom checkbox #2 - No Show and Cancellation Policy */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: 16,
            cursor: "pointer",
            padding: "12px",
            backgroundColor: "white",
            borderRadius: "6px",
            border: "1px solid #dee2e6",
            transition: "all 0.2s ease",
          }}
          onClick={() => {
            setAgreedToPolicy(!agreedToPolicy);
          }}
        >
          <div
            style={{
              width: 20,
              height: 20,
              border: "2px solid #ccc",
              borderRadius: 4,
              marginRight: 12,
              marginTop: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: agreedToPolicy ? "#FF8F2D" : "white",
              borderColor: agreedToPolicy ? "#FF8F2D" : "#ccc",
              flexShrink: 0
            }}
          >
            {agreedToPolicy && <i className="bx bx-check" style={{ color: "white", fontSize: 14 }}></i>}
          </div>
          <div style={{ color: "#495057", fontSize: 14, lineHeight: "1.4" }}>
            I agree to <span
              style={{
                color: "#FF8F2D",
                fontWeight: 600,
                textDecoration: "underline",
                cursor: "pointer"
              }}
              onClick={(e) => {
                e.stopPropagation();
                window.open("/noshow-policy/", "_blank");
              }}
            >No Show and Cancellation Policy</span> of Lavni Inc.
          </div>
        </div>

        {/* Custom checkbox #3 - Consent Document */}
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            cursor: "pointer",
            padding: "12px",
            backgroundColor: "white",
            borderRadius: "6px",
            border: "1px solid #dee2e6",
            transition: "all 0.2s ease",
          }}
          onClick={() => {
            setAgreedToConsent(!agreedToConsent);
          }}
        >
          <div
            style={{
              width: 20,
              height: 20,
              border: "2px solid #ccc",
              borderRadius: 4,
              marginRight: 12,
              marginTop: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: agreedToConsent ? "#FF8F2D" : "white",
              borderColor: agreedToConsent ? "#FF8F2D" : "#ccc",
              flexShrink: 0
            }}
          >
            {agreedToConsent && <i className="bx bx-check" style={{ color: "white", fontSize: 14 }}></i>}
          </div>
          <div style={{ color: "#495057", fontSize: 14, lineHeight: "1.4" }}>
            I agree to <span
              style={{
                color: "#FF8F2D",
                fontWeight: 600,
                textDecoration: "underline",
                cursor: "pointer"
              }}
              onClick={(e) => {
                e.stopPropagation();
                window.open("/consent-document/", "_blank");
              }}
            >Consent Document</span> of Lavni Inc.
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end">
        <button
          type="submit"
          className="btn btn-primary"
          disabled={isSubmitting || !agreedToDisclosure || !agreedToPolicy || !agreedToConsent}
          style={{
            backgroundColor: (agreedToDisclosure && agreedToPolicy && agreedToConsent) ? "#007bff" : "#cccccc",
            borderColor: (agreedToDisclosure && agreedToPolicy && agreedToConsent) ? "#007bff" : "#cccccc",
            cursor: (isSubmitting || !agreedToDisclosure || !agreedToPolicy || !agreedToConsent) ? "not-allowed" : "pointer"
          }}
        >
          Create Appointment
        </button>
      </div>
    </form>
  );
}
